// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RP-z","twoColumnImage":"SP-z"};